import { createActionType } from '../../helpers'

export const CREATE_USER_EVENT = createActionType(
  'USER_EVENTS',
  'CREATE_USER_EVENT'
)
